var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"customer-score"},[_vm._v(" "+_vm._s(_vm.customer.memberInfo.score || '0')+" "),_c('a',{on:{"click":function($event){$event.stopPropagation();return _vm.showScoreRecords($event)}}},[_vm._v("记录")])])}
var staticRenderFns = []

export { render, staticRenderFns }